import React, { useState, useRef } from 'react';
import { Play } from 'lucide-react';

const MusicProduct = ({ title, artist, description, price, imageUrl, audioSample, stripeLink }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [loading, setLoading] = useState(false);
  const audioRef = useRef(null);

  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handlePurchase = () => {
    if (stripeLink) {
      setLoading(true);
      window.location.href = stripeLink;
    } else {
      alert('Payment link not configured. Please add a Stripe payment link for this product.');
    }
  };

  return (
    <div className="product-card music-card">
      <div className="product-image-container">
        <img src={imageUrl} alt={title} className="product-image" />
        <div className="product-overlay">
          <button className="sample-btn" onClick={togglePlay}>
            <Play size={20} />
            {isPlaying ? 'Pause' : 'Play'} Sample
          </button>
        </div>
      </div>
      <div className="product-content">
        <h3 className="product-title">{title}</h3>
        <p className="product-author">{artist}</p>
        <p className="product-description">{description}</p>
        <div className="product-footer">
          <span className="product-price">${price}</span>
          <button 
            onClick={handlePurchase}
            disabled={loading}
            className="buy-btn"
          >
            {loading ? 'Loading...' : 'Buy Now'}
          </button>
        </div>
      </div>
      <audio ref={audioRef} src={audioSample} onEnded={() => setIsPlaying(false)} />
    </div>
  );
};

export default MusicProduct;
